import React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import { useStores } from '../../hooks/use-stores';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../Bootstrap/Portlet';
import './SideBar.css';

const SideBar = observer((props) => {
  const { sidebarStore } = useStores();
  const { children, className, type: sidebarType } = props;
  const { type } = sidebarStore;
  const CN = cx(className, {
    'portlet-widget-active sidebar': type === sidebarType,
    [`portlet-widget sidebar sidebar--${sidebarType}`]: true,
  });

  return (
    <Portlet className={CN}>
      <button className="btn btn-default btn-portlet-widget-toggle btn-hide"
        onClick={() => sidebarStore.onToggle(sidebarType)}>
        <i className={type === sidebarType ? 'fa fa-caret-right' : 'fa fa-caret-left'}/>
      </button>
      <PortletTitle>
        {props.title && <PortletCaption icon={props.icon} subject={props.title}/>}
        <a className="btn-close"
          onClick={() => {sidebarStore.onToggle(null);}}>Close
        </a>
      </PortletTitle>
      <PortletBody>
        {children}
      </PortletBody>
    </Portlet>
  );

});

export default SideBar;
